import { Chip } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const MissingValueBadge: FC = () => {
	const { t } = useResource();

	return (
		<Chip
			variant="tag"
			color="info"
			label={t(Resources.Portfolio.List.Redesign.missingValueBadge)}
		/>
	);
};
